import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import LandingPage from './components/LandingPage';
import AdminPanel from './components/AdminPanel';
import DevelopersPage from './components/DevelopersPage';
import APIDocumentation from './components/APIDocumentation';
import DeveloperAuth from './components/DeveloperAuth';
import DeveloperDashboard from './components/DeveloperDashboard';
import OccasionalShipping from './components/OccasionalShipping';
import MyShipments from './components/MyShipments';
import CustomerProfile from './components/CustomerProfile';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/developers" element={<DevelopersPage />} />
          <Route path="/documentazione-api" element={<APIDocumentation />} />
          <Route path="/developer-auth" element={<DeveloperAuth />} />
          <Route path="/developer-dashboard" element={<DeveloperDashboard />} />
          <Route path="/spedizione" element={<OccasionalShipping />} />
          <Route path="/le-mie-spedizioni" element={<MyShipments />} />
          <Route path="/profilo" element={<CustomerProfile />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;